<!-- sliderMenu component -->
<template>
  <!-- 第一层菜单 -->
  <div class="menu-box" @mouseout="outSiderMouse">
    <div v-iscroll class="menu-scroll border-shadow" :class="{'border-right':isShowClass3===true}">
      <div class="menu-class class-1">
        <div class="menu-item" :class="{'colorChooese':item.mid===chooesed1, 'bgChooese': item.mid === chooesedItem}" v-for="(item, index) in textData" :key="index" @mouseover="overMouse($event, 2, item)" @mouseout="outMouse($event)" @click="getTheForm(2, item.mid, item.menu_path, item.menu_name, item.menu_parent_id)">
          <span class="menu-item-text">{{item.menu_name}}</span>
          <div :class="item.mid===chooesed1? 'right-more-active' : 'right-more'" v-if="item.has_child"></div>
        </div>
      </div>
    </div>
    <!-- 子菜单 -->
    <div class="menu-sub">
      <div v-iscroll class="menu-scroll" :class="{'border-right':isShowClass3===true}" @mouseover="isShowClass2=true">
        <div class="menu-class class-2" v-show="isShowClass2 && class2data.length!==0">
          <div class="menu-item" :class="{'colorChooese':item.mid===chooesed2, 'bgChooese': item.mid === chooesedItem}" v-for="(item, index) in class2data" :key="index" @mouseover="overMouse($event, 3, item)" @mouseout="outMouse($event)" @click="getTheForm(3, item.mid, item.menu_path, item.menu_name, item.menu_parent_id)">
            <span class="menu-item-text">{{item.menu_name}}</span>
            <div :class="item.mid===chooesed2? 'right-more-active' : 'right-more'" v-if="item.has_child"></div>
          </div>
        </div>
      </div>
      <div v-iscroll class="menu-scroll" :class="{'border-right':isShowClass4===true}" @mouseover="isShowClass2=true;isShowClass3=true">
        <div class="menu-class class-3" v-show="isShowClass3&&class3data.length!==0">
          <div class="menu-item" :class="{'colorChooese':item.mid===chooesed3, 'bgChooese': item.mid === chooesedItem}" v-for="(item, index) in class3data" :key="index" @mouseover="overMouse($event, 4, item)" @mouseout="outMouse($event)" @click="getTheForm(4, item.mid, item.menu_path, item.menu_name, item.menu_parent_id)">
            <span class="menu-item-text">{{item.menu_name}}</span>
            <div :class="item.mid===chooesed3? 'right-more-active' : 'right-more'" v-if="item.has_child"></div>
          </div>
        </div>
      </div>
      <div v-iscroll class="menu-scroll" :class="{'border-right':isShowClass5===true}" @mouseover="isShowClass2=true;isShowClass3=true;isShowClass4=true">
        <div class="menu-class class-4" v-show="isShowClass4&&class4data.length!==0">
          <div class="menu-item" :class="{'colorChooese':item.mid===chooesed4, 'bgChooese': item.mid === chooesedItem}" v-for="(item, index) in class4data" :key="index" @mouseover="overMouse($event, 5, item)" @mouseout="outMouse($event)" @click="getTheForm(5, item.mid, item.menu_path, item.menu_name, item.menu_parent_id)">
            <span class="menu-item-text">{{item.menu_name}}</span>
            <div :class="item.mid===chooesed4? 'right-more-active' : 'right-more'" v-if="item.has_child"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import {addClass, removeClass} from 'utils/util'
export default {
  data () {
    return {
      isShowClass2: false,
      class2data: [],
      isShowClass3: false,
      class3data: [],
      isShowClass4: false,
      class4data: [],
      isShowClass5: false,
      chooesed1: 0,
      chooesed2: 0,
      chooesed3: 0,
      chooesed4: 0,
      chooesedItem: -1
    }
  },
  props: {
    textData: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    // 鼠标滑入
    overMouse (e, p, item) {
      this.chooesedItem = item.mid
      // 添加文字溢出的动画
      if (e.target.clientWidth > e.currentTarget.clientWidth) {
        addClass(e.target, 'moveInfinite')
      }
      // 滑入父元素加载子元素
      if (p === 2) {
        this.chooesed1 = item.mid
      } else if (p === 3) {
        this.chooesed2 = item.mid
      } else if (p === 4) {
        this.chooesed3 = item.mid
      } else if (p === 5) {
        this.chooesed4 = item.mid
      }
      if (item.has_child) {
        this['class' + p + 'data'] = item.children
        for (let i = 2; i <= p; i++) {
          this['isShowClass' + i] = true
        }
      } else {
        for (let i = 2; i <= p; i++) {
          this['isShowClass' + i] = false
        }
      }
    },
    // 鼠标滑出，去除文字溢出的动画
    outMouse (e) {
      if (e.target.clientWidth > e.currentTarget.clientWidth) {
        removeClass(e.target, 'moveInfinite')
      }
    },
    // 滑出关闭子元素
    outSiderMouse (e) {
      this.isShowClass2 = false
      this.isShowClass3 = false
      this.isShowClass4 = false
    },
    getTheForm (p, mid, path, name, pid) {
      this['chooesed' + p] = mid
      this.$emit('chooseId', mid, path, name, pid)
    }
  },
  watch: {
    chooesed1 () {
      this.isShowClass3 = false
      this.isShowClass4 = false
      this.class3data = []
      this.class4data = []
    }
  }
}
</script>
<style lang="less">
@import '~assets/style/mixin.less';
@import '~assets/style/variable.less';
.moveInfinite {
  animation: move 2s infinite;
  -webkit-animation: move 2s infinite;
}
@keyframes move {
  from { left: 0px; }
  to { left: -50px; }
}
@-webkit-keyframes move {
  from { left: 0px; }
  to { left: -50px; }
}
.menu-scroll {
  overflow: hidden;
  height: 100%;
  position: relative;
}
.menu-box {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  font-size: @font-size-medium;
  width: 100%;
}
.border-shadow {
  box-shadow: 1px 0 4px rgba(204, 204, 204, 0.5);
}
.border-right {
  border-right: 1px solid rgba(204, 204, 204, 0.3);
}
.menu-sub {
  position: absolute;
  left: 200px;
  top: 0;
  bottom: 0;
  display: flex;
  height: 100%;
  background: #fff;
  z-index: 10;
  box-shadow: 1px 0 4px rgba(204, 204, 204, 0.5);
}
.menu-class {
  opacity: 1;
  width: 200px !important;
  .menu-item {
    width: 200px;
    line-height: 44px;
    height: 44px;
    position: relative;
    overflow: hidden;
    .cursor-pointer;
    .right-more {
      content: '';
      display: inline-block;
      border-top: 1px solid #333;
      border-right: 1px solid #333;
      height: 9px;
      width: 9px;
      position: absolute;
      right: 20px;
      top: 50%;
      transform: rotate(45deg) translateY(-50%);
    }
    .right-more-active {
      content: '';
      display: inline-block;
      border-top: 1px solid @color-theme;
      border-right: 1px solid @color-theme;
      height: 9px;
      width: 9px;
      position: absolute;
      right: 20px;
      top: 50%;
      transform: rotate(45deg) translateY(-50%);
    }
  }
  .menu-item-text {
    display: inline-block;
    white-space: nowrap;
    padding: 0 14px;
    margin-left: 3px;
    position: absolute;
    top: 0 ;
    left: 0;
  }
}
.colorChooese {
  color: @color-theme;
}
.bgChooese {
  color: @color-theme;
  background-color: @color-bg-grey;
}
.iScrollVerticalScrollbar {
  width: 3px;
  position: absolute;
  top: 2px;
  height: 100%;
  right: 0px;
}
.iScrollVerticalScrollbar .iScrollIndicator {
  width: 100%;
  background: @color-light-g;
  height: 9px;
  border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/sliderMenu.vue